import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Card from "shared/components/horizon-ui/card/Card";
import InfiniteTable from "shared/components/table/InfiniteTable";
import PageTitle from "../admin/PageTitle";
import {
  useGetColumns,
  useGetFilterFields,
  useGetGetBreadcrumbs,
} from "./constants";
import { LinksT } from "../../api/types/links";
import { useGetLinks, useToggleHiddenLink } from "../../api/requests/links";
import { LayoutsE, PathsE } from "../../routes";
import MuiIcon from "../../../components/MuiIcon";
import Link from "../../components/Link";
import { TableNameE } from "shared/api/types/common";

const Index = () => {
  const { t } = useTranslation();
  const { mutate: toggleHiddenLink } = useToggleHiddenLink();
  const handleHidden = (linkId: string) => toggleHiddenLink({ linkId });

  const columns = useGetColumns({handleHidden});
  const breadcrumbs = useGetGetBreadcrumbs();
  const filterFields = useGetFilterFields();

  return (
    <Box>
      <PageTitle title={t("dtos.link_other")} breadcrumbs={breadcrumbs} />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex
          alignItems="center"
          flexDirection={{ "3sm": "row", sm: "column" }}
        >
          <Link layout={LayoutsE.DASHBOARD} path={PathsE.CREATE_BOTS_LINK}>
            <Button
              fontSize="16px"
              color="white"
              backgroundColor="brand.500"
              fontWeight="600"
              _hover={{
                backgroundColor: "brand.400",
              }}
              paddingY="8px"
              paddingX="6px"
              display="flex"
              borderRadius="8px"
              alignItems="center"
              mb={{ sm: "6px", "3sm": "0" }}
            >
              <MuiIcon name="add" size={24} color="gray800" variant="rounded" />
              <Text ml="8px">{t("links.botsLink")}</Text>
            </Button>
          </Link>
          <Link layout={LayoutsE.DASHBOARD} path={PathsE.CREATE_CHANNELS_LINK}>
            <Button
              fontSize="16px"
              ml={{ "3sm": "10px" }}
              color="white"
              backgroundColor="brand.500"
              fontWeight="600"
              _hover={{
                backgroundColor: "brand.400",
              }}
              paddingY="8px"
              paddingX="6px"
              display="flex"
              borderRadius="8px"
              alignItems="center"
            >
              <MuiIcon name="add" size={24} color="gray800" variant="rounded" />
              <Text ml="8px">{t("links.channelsLink")}</Text>
            </Button>
          </Link>
        </Flex>
        <InfiniteTable<LinksT>
          query={useGetLinks}
          columns={columns}
          filterFields={filterFields}
          tableName={TableNameE.LINKS}
        />
      </Card>
    </Box>
  );
};

export default Index;
